// extracted by mini-css-extract-plugin
export default {"start":"DrawRaffleButton_start__B7Uw-","confirm":"DrawRaffleButton_confirm__V-v9N","question":"DrawRaffleButton_question__nEkvj","actions":"DrawRaffleButton_actions__MWd8w"};